module.exports = __webpack_public_path__ + "img/image_01sp.a7c1a7f6.jpg";